import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { IDigitalWalletRewardShip } from '../../models/digital-wallet-rewards.interface';

@Component({
    selector: 'upsc-invoice-card',
    templateUrl: './invoice-card.component.html',
    styleUrls: ['./invoice-card.component.scss'],
})
export class InvoiceCardComponent {
    @Input() public item: IDigitalWalletRewardShip;
    @Output() public itemSelected = new EventEmitter<IDigitalWalletRewardShip>();
    @Output() public downloadInvoiceClicked = new EventEmitter<IDigitalWalletRewardShip>();
    @Output() public redeemClicked = new EventEmitter<IDigitalWalletRewardShip>();

    @HostBinding('class') public hostClass = 'invoice-card';

    constructor() {
    }

    public downloadInvoice(event: MouseEvent): void {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        this.downloadInvoiceClicked.emit(this.item);
    }

    public redeem(event: MouseEvent): void {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        this.redeemClicked.emit(this.item);
    }
}
